export default "__VITE_ASSET__Dj24UiZ3__"